document.addEventListener("turbolinks:load", function () {
  const header = document.getElementById("electronicVotingHeader");
  if (!header) return; // Ensure script runs only when the section exists

  // Map links to their respective headings
  const linksToHeaders = {
      "Initial Requirements": "initial_requirements",
      "Electronic Consent Notice": "electronic_consent_notice",
      "Electronic Nomination Form Email": "electronic_nomination_form",
      "Electronic Pre-Ballot Notification Email": "electronic_pre_ballot_notification",
      "Electronic Ballot": "electronic_ballot",
      "Results": "results"
  };

  // Add event listeners for smooth scrolling
  Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const targetElement = document.getElementById(targetId);

      if (link && targetElement) {
          link.addEventListener("click", function (event) {
              event.preventDefault();
              window.scrollTo({
                  top: targetElement.offsetTop - 100, // Adjust for fixed headers
                  behavior: "smooth"
              });
          });
      }
  });
});

